import { Box, Grid, Typography } from '@mui/material';
import { ApplicationProps } from '../../redux-store/types/api-types';
import { Gridstyles } from '../Investments/investor-application';
import { KeyValue } from './contributor';
import { styles } from '../../Styles/styles';
import { useSelector } from 'react-redux';
import { RootStateType } from '../../redux-store/reducers';
import { checkSupportLogin, getOlderDate } from '../../utils/utilityFunctions';
import { POAAuthorizedSignatry } from '../NonIndividualApplicationDetails/AuthorisedSignatories';
import {
  checkIfApplicationIsIndividualPOA,
  checkValidationBasedOnDate,
} from '../../utils/utilityFunctions';
import {
  POA_AUTHORIZED_SIGNATORY_INDIVIDUAL_FLOW_VISIBLITY_ENABLE,
  poaValidationDate,
} from '../../utils/constant';
import { useFeatureToggles } from '../../utils/useDataMdms';

export default function DistributorDetails({
  application,
}: {
  application: ApplicationProps;
}): JSX.Element {
  const { auth } = useSelector((store: RootStateType) => store);
  const { toggler } = useFeatureToggles();
  const { poaValidationDate = '' } = toggler?.dateFeatureToggles || {};
  return (
    <>
      <Box sx={styles.ApplicationDetailsCommonLayout}>
        <Box sx={{ p: 2 }}>
          <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 } }}>
            <Grid container direction="row" justifyContent="space-between" alignItems="flex-start">
              <Typography
                component="h2"
                sx={{ fontSize: 18, fontWeight: 600, color: 'primary.main', m: 0 }}>
                RM/Distributor Details
              </Typography>
            </Grid>

            <Gridstyles sx={{ width: '100%' }}>
              <Grid
                item
                container
                pt={1}
                pb={5}
                rowSpacing={6}
                columnSpacing={13}
                direction="row"
                justifyContent="space-between"
                alignItems="flex-start">
                {application.distributor_id && (
                  <>
                    {' '}
                    <KeyValue
                      title={'Distributor Name'}
                      description={application?.distributor?.name}
                    />
                    <KeyValue
                      title={'Distributor ARN Code'}
                      description={application?.distributor?.arnCode || 'NA'}
                    />
                    {!application?.subdistributorId && (
                      <KeyValue
                        title={'Distributor Email Id'}
                        description={application?.distributor?.user?.email}
                      />
                    )}
                    {application?.subdistributorId && (
                      <KeyValue
                        title={'Distributor RM Name'}
                        description={application?.subDistributor?.user?.firstName}
                      />
                    )}
                    {application?.subdistributorId && (
                      <KeyValue
                        title={'Distributor RM Code'}
                        description={application?.subDistributor?.distributors_RM_Code || 'NA'}
                      />
                    )}
                    {application?.subdistributorId && (
                      <KeyValue
                        title={'Distributor RM Email Id'}
                        description={application?.subDistributor?.user?.email}
                      />
                    )}
                  </>
                )}

                {application?.distributorName && (
                  <KeyValue title={'Distributor Name'} description={application?.distributorName} />
                )}
                {application?.distributorArnCode && (
                  <KeyValue
                    title={'Distributor ARN Code'}
                    description={application?.distributorArnCode}
                  />
                )}
                {application?.distributorRmName && (
                  <KeyValue
                    title={'Distributor RM Name'}
                    description={application?.distributorRmName}
                  />
                )}
                {application?.supportSubdistributor?.user.id && (
                  <>
                    <KeyValue
                      title={'CSE Name'}
                      description={application?.supportSubdistributor?.user?.firstName}
                    />
                    <KeyValue
                      title={'CSE Email'}
                      description={application?.supportSubdistributor?.user?.email}
                    />
                    <KeyValue
                      title={'CSE Code'}
                      description={application?.supportSubdistributor?.distributors_RM_Code || 'NA'}
                    />
                  </>
                )}
                <KeyValue title={'AMC RM Name'} description={application?.rm?.name} />
                <KeyValue title={'AMC RM Email Id'} description={application?.rm?.user?.email} />
                <KeyValue title={'AIF RM Name'} description={application?.aifRmName} />
              </Grid>
            </Gridstyles>
          </Grid>
          {application?.poaauthorisedsignatories?.length >= 0 &&
            checkValidationBasedOnDate(
              getOlderDate(application?.createdAt || '', application?.applicationCreatedAt || ''),
              poaValidationDate
            ) &&
            checkIfApplicationIsIndividualPOA(application) &&
            POA_AUTHORIZED_SIGNATORY_INDIVIDUAL_FLOW_VISIBLITY_ENABLE && (
              <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 } }}>
                <Typography
                  component="h2"
                  sx={{ fontSize: 18, fontWeight: 600, color: 'primary.main', m: 0 }}>
                  Authorised Signatories
                </Typography>
                {application?.poaauthorisedsignatories?.length === 0 ? (
                  <Grid
                    xs={12}
                    sm={12}
                    sx={{
                      fontSize: 18,
                      fontWeight: 600,
                      color: 'common.black',
                      textAlign: 'center',
                      my: 3,
                    }}>
                    No Authorised Signatories
                  </Grid>
                ) : (
                  <POAAuthorizedSignatry />
                )}
              </Grid>
            )}
        </Box>
      </Box>
    </>
  );
}
